import { Box, Link, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';

const Footer = () => {
    const location = useLocation();
    const [adminRoute, setAdminRoute] = useState(false);

    useEffect(() => {
        setAdminRoute(location.pathname.split("/").includes("admin"))
    }, [location]);

    const footerLinks = [
        { name: "About", url: "https://shreejisecuresofttech.com/about" },
        { name: "Privacy Policy", url: "https://shreejisecuresofttech.com/privacy-policy" },
        { name: "Terms & Conditions", url: "https://shreejisecuresofttech.com/terms-conditions" },
        { name: "Shipping Policy", url: "https://shreejisecuresofttech.com/shipping-policy" },
        { name: "Return, Refund and Cancellation Policy", url: "https://shreejisecuresofttech.com/refund-policy" },
        { name: "Payment Policy", url: "https://shreejisecuresofttech.com/payment-policy" },
        { name: "Cookie Policy", url: "https://shreejisecuresofttech.com/cookie-policy" },
        { name: "Contact", url: "https://shreejisecuresofttech.com/contact" },
    ];

    return (
        <>
            {!adminRoute && (
                <Box
                    component="footer"
                    sx={{
                        py: 2,
                        px: 2,
                        mt: 'auto',
                        backgroundColor: (theme) =>
                            theme.palette.mode === 'light'
                                ? theme.palette.grey[200]
                                : theme.palette.grey[800],
                        textAlign: 'center',
                    }}
                >
                    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mb: 1 }}>
                        {footerLinks.map((link) => (
                            <Link
                                href={link.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                key={link.name}
                                underline="hover"
                                color="inherit"
                            >
                                {link.name}
                            </Link>
                        ))}
                    </Box>
                    <Typography variant="body2" color="text.secondary">
                        © {new Date().getFullYear()} Shree Ji Secure Soft Tech
                    </Typography>
                </Box>
            )}
        </>
    );
};

export default Footer;
